import React from 'react'
import * as Comp from '../../app/features/AboutPackage';
import { GET_REQUEST } from "../../HooksApi/useApi";
import UseGetData from "../../HookAxios/getdata";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import DotsLoader from '../../Components/Loader/Dots';
const AboutPackage = () => {
  const { PackId } = useParams()
  const token = useSelector((state) => state.Auth.userInfo.token)
  const dispatch = useDispatch()

  const { isLoading, data }
    = GET_REQUEST({
      queryKey: `aboutCourse${PackId}`, request: () => UseGetData('get_package_details',
        { package_id: PackId }, { "Authorization": `Bearer ${token}` }), enabled: true
    })
    console.log("the package data is ", data)


  return (
    <div style={{ minHeight: '120vh' }}>
      {
        !isLoading && data?.data?.data?.package_info ?
          <>
            <Comp.Header
              name={data?.data?.data?.package_info[0].name}
              new_price={data?.data?.data?.package_info[0].new_price}
              old_price={data?.data?.data?.package_info[0].old_price}
              imgUrl={data?.data?.data?.package_info[0].image_path}
              cost2={data?.data?.data?.package_info[0].cost2}
              cost4={data?.data?.data?.package_info[0].cost4}
              cost5={data?.data?.data?.package_info[0].cost5}
              is_subscribed = {data?.data?.data?.is_subscribtion}
            />
            <Comp.DepartmentCourse
              courses={data?.data?.data?.package_info[0].courses}
            />
          </> : <DotsLoader />
      }
    </div>
  )
}

export default AboutPackage